// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".guide-link-wrap[data-v-1d4b7725] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.guide-link-wrap a[data-v-1d4b7725] {\n    color: #0E6CCB;\n    text-decoration: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
